import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminService from "../../APIService/AdminService";
import {
  getPageDecorations,
  setDocumentTitle,
  useSiteNameContext,
} from "../../context/siteNameContext";
import Loading from "../../shared/loading";
import { TEditTask } from "../../types";
import EditForm from "./EditForm";
import { editCreateTaskColumns } from "../../editColumnsConfig";
import { Link } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function TaskViewPage() {
  const { siteNameList } = useSiteNameContext();
  // setDocumentTitle(siteNameList, "task/view");
  const decorations = getPageDecorations(siteNameList, "task/view");
  const params = useParams();
  const taskId = params.id;
  const [editItem, setEditItem] = useState<TEditTask>({ id: 0 });
  const [isLoading, setIsLoading] = useState<boolean>(true);

  if (decorations?.title) {
    window.document.title = decorations.title.replace(
      /%task_id/g,
      taskId?.toString(),
    );
  }

  useEffect(() => {
    const fetchItem = async (id: number) => {
      const response = await AdminService.getTaskById(id);
      setEditItem(response.data);
    };

    fetchItem(Number(taskId)).then(() => setIsLoading(false));
  }, [taskId]);

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  return (
    <div className="Wrapper">
      <h1>{decorations?.header1 || "Просмотр задачи"}</h1>
      <p dangerouslySetInnerHTML={{ __html: decorations?.text1 }}></p>
      <hr />

      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Link
            to={`/admin/task/edit/${editItem.id}`}
            onClick={async (e) => {
              const t = e.currentTarget.pathname;
              e.preventDefault();
              AdminService.lockTaskForEdit(editItem.id)
                .catch((e: any) => {
                  enqueueSnackbar(e.response.data.message, {
                    variant: "error",
                    anchorOrigin: { horizontal: "right", vertical: "top" },
                  });
                })
                .then((r) => {
                  if (r?.status === 200) navigate(t);
                });
            }}
          >
            <button className="TaskEditLink">Редактировать</button>
          </Link>
          <EditForm
            courseOrTask="task"
            editItem={editItem}
            editColumns={editCreateTaskColumns}
            setItem={() => {}}
            readOnly={true}
          />
        </>
      )}
    </div>
  );
}
